import React from 'react';
import {Asset, AssetOrAssetContainer} from '../../../../types';
import GroupRow from '../GroupRow';
import {Grid2 as Grid} from '@mui/material';
import AssetItem from './AssetItem';
import {LayoutPageProps, OnPreviewToggle} from '../../types';
import SectionDivider from '../../SectionDivider';

type Props<Item extends AssetOrAssetContainer> = {
    onPreviewToggle?: OnPreviewToggle;
} & LayoutPageProps<Item>;

function GridPage<Item extends AssetOrAssetContainer>({
    items,
    itemToAsset,
    onContextMenuOpen,
    onOpen,
    onPreviewToggle,
    onToggle,
    selection,
    disabledAssets,
    toolbarHeight,
    page,
    itemComponent,
    itemOverlay,
}: Props<Item>) {
    return (
        <>
            {page > 1 && (
                <SectionDivider
                    top={toolbarHeight}
                    textSx={() => ({
                        fontWeight: 700,
                        fontSize: 15,
                    })}
                >
                    # {page}
                </SectionDivider>
            )}
            {items.map(item => {
                const asset: Asset = itemToAsset
                    ? itemToAsset(item)
                    : (item as unknown as Asset);

                return (
                    <GroupRow key={item.id} asset={asset} top={toolbarHeight}>
                        <Grid
                            onDoubleClick={() => onOpen?.(asset)}
                            onContextMenu={
                                onContextMenuOpen
                                    ? e => {
                                          onContextMenuOpen!(e, item);
                                      }
                                    : undefined
                            }
                        >
                            <AssetItem
                                item={item}
                                itemOverlay={itemOverlay}
                                itemComponent={itemComponent}
                                asset={asset}
                                selected={selection.includes(item)}
                                disabled={disabledAssets.includes(item)}
                                onContextMenuOpen={onContextMenuOpen}
                                onOpen={onOpen}
                                onToggle={onToggle}
                                onPreviewToggle={onPreviewToggle}
                            />
                        </Grid>
                    </GroupRow>
                );
            })}
        </>
    );
}

export default React.memo(GridPage) as typeof GridPage;
